import { faSave } from "@fortawesome/free-solid-svg-icons";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { useHistoricoContext } from "../../../Context/Historico";
import {
    InserirCasoStatusController,
    ListarStatusEtapaController,
    ListarStatusEtapaFixosController,
} from "../../../Controllers/Repasse/StatusEtapa/StatusEtapaController";
import useAsyncCallback from "../../../hooks/useAsyncCallback";
import useAsyncEffect from "../../../hooks/useAsyncEffect";
import { IStatusEtapa } from "../../../Interfaces/Repasse/StatusEtapa/StatusEtapaInterface";
import UnForm from "../../Form";
import OrSpinner from "../../Utils/OrSpinner";
import { useAtendimentoPage } from "../../../Context/AtendimentoPage";
import { useModuloInfo } from "../../../Context/ModuloInfo";
import { ACESSOS } from "../../../Routes/Acessos";

interface IStatusEtapaProps {
    idEtapaCategoriaAtendimentoTipoCaso?: number;
    idCaso: number;
    setBloquearAcoes: Dispatch<SetStateAction<boolean>>;
    idEtapaTipoCaso?: number;
}

interface IStatusEtapaForm {
    LST_ID_STATUS_ETAPA: number[];
}

export default function StatusEtapa(props: IStatusEtapaProps) {
    const { ReloadHistorico } = useHistoricoContext();
    const [statusEtapa, setStatusEtapa] = useState<
        IStatusEtapa[] | undefined
    >();

    const { Atendimento } = useAtendimentoPage();

    const { id } = useModuloInfo();

    const {
        value: statusEtapaDinamicas,
        loading: statusEtapaDinamicasLoading,
        execute: updateListDinamica,
    } = useAsyncEffect(async () => {
        if (props.idEtapaCategoriaAtendimentoTipoCaso) {
            return ListarStatusEtapaController(
                props.idEtapaCategoriaAtendimentoTipoCaso ?? 0,
                props.idCaso
            );
        }
    }, [
        props.idCaso,
        props.idEtapaCategoriaAtendimentoTipoCaso,
        Atendimento?.ID_ETAPA_TIPO_CASO,
    ]);

    const {
        value: statusEtapaFixas,
        loading: statusEtapaFixasLoading,
        execute: updateListFixas,
    } = useAsyncEffect(async () => {
        if (props.idEtapaTipoCaso) {
            return ListarStatusEtapaFixosController(
                props.idEtapaTipoCaso ?? 0,
                props.idCaso
            );
        }
    }, [
        props.idCaso,
        props.idEtapaTipoCaso,
        props.idEtapaCategoriaAtendimentoTipoCaso,
        Atendimento?.ID_ETAPA_TIPO_CASO,
    ]);

    useEffect(() => {
        if (statusEtapaDinamicas) {
            return setStatusEtapa(statusEtapaDinamicas);
        } else {
            return setStatusEtapa(statusEtapaFixas);
        }
    }, [statusEtapaFixas, statusEtapaDinamicas]);

    function handleMostrarAcoes() { 
        //ID_ETAPA_TIPO_CASO são para os casos de módulos com etapas fixas,
        //como Vendas e Assistência Técnica. No Atendimento ao Cliente é dinâmico, 
        //as etapas ficam ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO
        if (ACESSOS.VENDAS.ID_MODULO !== id && ACESSOS.ASSISTENCIA.ID_MODULO !== id) {
            const bloquear = statusEtapaDinamicas?.some(
                (status) => status.FL_OBRIGATORIO && !status.FL_STATUS_ETAPA
            );
            props.setBloquearAcoes(bloquear ?? false);
        } else {
            const bloquear = statusEtapaFixas?.some(
                (status) => status.FL_OBRIGATORIO && !status.FL_STATUS_ETAPA
            );
            props.setBloquearAcoes(bloquear ?? false);
        }
    }

    handleMostrarAcoes();

    const { execute: inserirCaso, loading: inserirCasoLoading } =
        useAsyncCallback(InserirCasoStatusController);

    function handleStatusEtapa(formData: IStatusEtapaForm) {
        if (statusEtapa && statusEtapa.length > 1) {
            const idStatusNumber = formData.LST_ID_STATUS_ETAPA.map(Number);
            const idStatus = idStatusNumber.filter((f) => f !== 0);

            inserirCaso({
                ID_CASO: props.idCaso,
                LST_ID_STATUS_ETAPA: idStatus,
            }).then(() => {
                if (statusEtapaDinamicas) {
                    updateListDinamica();
                } else {
                    updateListFixas();
                }
                ReloadHistorico();
            });
        } else {
            const idStatusNumber = Number(formData.LST_ID_STATUS_ETAPA);

            inserirCaso({
                ID_CASO: props.idCaso,
                LST_ID_STATUS_ETAPA: [idStatusNumber],
            }).then(() => {
                if (statusEtapaDinamicas) {
                    updateListDinamica();
                } else {
                    updateListFixas();
                }
                ReloadHistorico();
            });
        }
    }

    return (
        <OrSpinner
            loading={statusEtapaDinamicasLoading || statusEtapaFixasLoading}
            loadingSize="sm"
            spinner="capys"
        >
            {statusEtapa && statusEtapa.length > 0 && (
                <div className="d-flex card card-custom justify-content-around p-4 my-5">
                    <UnForm handleSubmit={handleStatusEtapa}>
                        <div className="d-flex justify-content-between align-items-center py-2">
                            <div className="mx-auto text-center">
                                <h4 className="mb-0">Status por Etapa</h4>
                            </div>
                            <div>
                                <UnForm.SubmitButton
                                    noDiv={true}
                                    icon={faSave}
                                    color="primary"
                                    className="btn btn-clean btn-success btn-icon ml-2 mr-2"
                                    loading={inserirCasoLoading}
                                    loadingSize="sm"
                                    iconSize="lg"
                                    disabled={
                                        inserirCasoLoading ||
                                        statusEtapaDinamicas?.length === 0
                                    }
                                ></UnForm.SubmitButton>
                            </div>
                        </div>

                        <hr />
                        <div className="d-flex justify-content-around align-items-center col-12 p-5 flex-wrap g-5">
                            {statusEtapa?.map((status) => (
                                <div className="d-flex flex-column align-items-center">
                                    <label>
                                        {status.DS_STATUS_ETAPA}{" "}
                                        {status.FL_OBRIGATORIO && (
                                            <span className="text-danger">
                                                *
                                            </span>
                                        )}
                                    </label>
                                    <UnForm.Input
                                        type="checkbox"
                                        name="LST_ID_STATUS_ETAPA"
                                        disabled={Boolean(
                                            status.ID_CASO_STATUS
                                        )}
                                        defaultChecked={status.FL_STATUS_ETAPA}
                                        value={
                                            !status.ID_CASO_STATUS
                                                ? status.ID_STATUS_ETAPA
                                                : undefined
                                        }
                                        style={{ height: 30, width: 30 }}
                                    />
                                </div>
                            ))}
                        </div>

                        <div className="d-flex justify-content-end mt-3 mb-5">
                            {/* <button
                            className="btn btn-clean btn-success btn-icon btn-md ml-2 mr-2"
                            onClick={() => {
                                handleDocsSubmit();
                            }}
                        >
                            <FontAwesomeIcon icon={faSave} size="lg" />
                        </button> */}
                        </div>
                    </UnForm>
                </div>
            )}
        </OrSpinner>
    );
}
